import { Loading, isSuccess, useDynamicConfig } from "@dgs/core";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useNavigate, useParams } from "react-router";
import { eventService as sharedEventService } from "../../../shared/api/eventService";
import { mapEventToFormValues } from "../../../shared/events/save/eventFormUtils";
import { UpdateEvent } from "../../../shared/events/save/UpdateEvent";
import { eventService } from "../shared/api/event/eventService";

export const UpdateEventPage: FC = () => {
	const { eventId = "" } = useParams();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { defaultCurrency } = useDynamicConfig();

	const { data: event, isLoading } = useQuery({
		queryKey: sharedEventService.showKey(eventId),
		queryFn: () => sharedEventService.show(eventId).then((x) => x.data.data),
	});

	if (isLoading || !event) {
		return <Loading />;
	}

	return (
		<UpdateEvent
			initialValues={mapEventToFormValues(event, defaultCurrency)}
			onSubmit={async (request) => {
				const response = await sharedEventService.update(eventId, request);
				void queryClient.invalidateQueries({ queryKey: eventService.indexKey });
				void queryClient.invalidateQueries({ queryKey: eventService.detailKey(eventId) });

				if (isSuccess(response)) {
					navigate(`/events/active/${eventId}/details`);
				}
			}}
		/>
	);
};
